module.exports = __webpack_public_path__ + "static/img/2.2f7c1fe7.png";